<template>
  <div>
    <div class="mb-6 cursor-pointer" :class="{ 'text': !active, 'text-active': active }" @click="openImageModal">
      <p>{{ publication.title }}</p>
      <p v-if="publication.in_publication">In: {{ publication.in_publication }}</p>
      <p v-if="publication.quota">Cota: {{ publication.quota }}</p>
    </div>

    <modal :name="modalName" :adaptive="true" :scrollable="true" height="auto" :shift-x="modalXOffset" styles="background-color: transparent; box-shadow: none;">
      <button @click="closeImageModal" class="close"></button>
      <div style="height: inherit; padding: 5%;" class="flex justify-end">
        <img style="height: 100%;" :src="coverUrl" :key="coverUrl" :alt="publication.title">
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "Publication",
  props: {
    publication: {
      type: Object,
      require: true
    },
    active: Boolean
  },
  data: () => ({
    windowWidth: window.innerWidth,
  }),
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    coverUrl() {
      return `covers/${this.publication.cover_file_name}`
    },
    modalName() {
      return `${this.publication.id}#${this.coverUrl}`
    },
    modalXOffset() {
      return this.windowWidth > 768 ? 0.75 : 0.5;
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
    openImageModal: function () {
      this.$modal.show(this.modalName)
    },
    closeImageModal: function () {
      this.$modal.hide(this.modalName)
    }
  }
}
</script>

<style scoped>
.close {
  position: absolute;
  z-index: 999;
  top: 0;
  right: 0;
  display: block;
  width: 50px;
  height: 50px;
  font-size: 0;
  opacity: 0.3;
  background: #231F20;
  margin: 5%;
}

.close:hover {
  opacity: 0.9;
}

.close:before,
.close:after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3px;
  height: 40px;
  background-color: #86888B;
  transform: rotate(45deg) translate(-50%, -50%);
  transform-origin: top left;
  content: '';
}

.close:after {
  transform: rotate(-45deg) translate(-50%, -50%);
}
</style>
